// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"beb8b37a","453":"a0d61c50","732":"14d206b2","977":"7227772f"}[chunkId] + ".chunk.js";
};